import { Link } from "react-router-dom";

/**
 * Dominanter Ergebnis-Screen nach dem Fight — Score, Status, ein klarer Weiter-Button.
 */
const moneyDe = (n) =>
  `${Number(n || 0).toLocaleString("de-DE")} €`;

const MatchResultScreen = ({
  headline = "Spiel beendet",
  scoreLabel = "",
  homeName = "Heim",
  awayName = "Gast",
  scoreHome = null,
  scoreAway = null,
  won = null,
  moneyEarned = null,
  moneyHint = "",
  moneyBreakdown = null,
  body = "",
  journey = [],
  nextTitle,
  nextHint,
  primaryLabel,
  primaryTo,
  onPrimary,
  secondaryLabel,
  secondaryTo,
  onSecondary,
  busy = false,
  onToggleDetails,
  detailsOpen = false,
}) => {
  const Primary = primaryTo ? Link : "button";
  const primaryProps = primaryTo
    ? { to: primaryTo, onClick: onPrimary }
    : { type: "button", onClick: onPrimary, disabled: busy };

  const tone =
    won === true
      ? "from-emerald-700 to-teal-800 border-emerald-400"
      : won === false
        ? "from-slate-700 to-slate-900 border-slate-400"
        : "from-amber-700 to-orange-900 border-amber-300";

  const moneyNum = moneyEarned != null && moneyEarned !== "" ? Number(moneyEarned) : null;
  const showMoney = moneyNum != null && !Number.isNaN(moneyNum) && moneyNum !== 0;
  const bd = moneyBreakdown || {};
  const parts = [
    Number(bd.leaguePayout) > 0 ? `Liga ${moneyDe(bd.leaguePayout)}` : null,
    Number(bd.homeCrowd) > 0 ? `Heim ${moneyDe(bd.homeCrowd)}` : null,
    Number(bd.sponsorShare) > 0 ? `Sponsor ${moneyDe(bd.sponsorShare)}` : null,
  ].filter(Boolean);

  return (
    <section
      className={`rounded-3xl border-2 bg-gradient-to-br text-white shadow-2xl overflow-hidden ${tone}`}
    >
      <div className="px-6 pt-6 pb-2">
        <div className="text-[11px] uppercase tracking-[0.25em] opacity-80 mb-2">Endstand</div>
        <div className="flex flex-wrap items-end justify-between gap-4 mb-3">
          <div className="min-w-0">
            <h2 className="text-3xl md:text-4xl font-black tracking-tight">{headline}</h2>
          </div>
          <div className="text-5xl md:text-6xl font-black tabular-nums tracking-tight">
            {scoreHome != null && scoreAway != null ? (
              <>
                {scoreHome}
                <span className="mx-2 opacity-50">:</span>
                {scoreAway}
              </>
            ) : (
              <span className="text-2xl opacity-80">{scoreLabel}</span>
            )}
          </div>
        </div>
        <div className="text-sm opacity-80 mb-3 truncate">
          {homeName} <span className="opacity-50">vs</span> {awayName}
        </div>

        {showMoney ? (
          <div className="mb-4 rounded-2xl bg-yellow-300 text-gray-900 px-4 py-3 shadow-lg">
            <div className="text-[11px] uppercase tracking-[0.2em] font-bold opacity-70 mb-1">
              Spieltagseinnahmen
            </div>
            <div className="text-3xl md:text-4xl font-black tabular-nums leading-none">
              {moneyNum > 0 ? "+" : ""}
              {moneyDe(moneyNum)}
            </div>
            {parts.length ? (
              <p className="mt-2 text-sm font-semibold opacity-80">{parts.join(" · ")}</p>
            ) : null}
            {moneyHint ? <p className="mt-1 text-sm opacity-75">{moneyHint}</p> : null}
          </div>
        ) : moneyHint ? (
          <p className="text-sm opacity-85 mb-3">{moneyHint}</p>
        ) : null}

        {scoreLabel ? <p className="text-sm opacity-85 mb-3">{scoreLabel}</p> : null}
        {body ? <p className="opacity-90 leading-relaxed mb-5 max-w-2xl">{body}</p> : null}

        {journey.length ? (
          <ol className="flex flex-wrap gap-2 mb-6 text-xs font-semibold">
            {journey.map((step) => (
              <li
                key={step.key}
                className={`px-2.5 py-1 rounded-full border ${
                  step.done
                    ? "bg-white/25 border-white/40"
                    : step.current
                      ? "bg-yellow-300 text-gray-900 border-yellow-200 ring-2 ring-yellow-100"
                      : "bg-black/20 border-white/20 opacity-70"
                }`}
              >
                {step.done ? "✓ " : step.current ? "→ " : ""}
                {step.label}
              </li>
            ))}
          </ol>
        ) : null}
      </div>

      <div className="bg-black/25 px-6 py-5 border-t border-white/15">
        <div className="text-[11px] uppercase tracking-widest opacity-70 mb-1">Als Nächstes</div>
        <h3 className="text-2xl font-black mb-2">{nextTitle}</h3>
        {nextHint ? <p className="opacity-90 mb-4 leading-relaxed">{nextHint}</p> : null}
        <div className="flex flex-wrap gap-3">
          <Primary
            {...primaryProps}
            className="inline-flex px-6 py-3.5 rounded-xl bg-yellow-300 text-gray-900 font-black text-lg hover:bg-yellow-200 disabled:opacity-60"
          >
            {primaryLabel}
          </Primary>
          {secondaryLabel && (secondaryTo || onSecondary) ? (
            secondaryTo ? (
              <Link
                to={secondaryTo}
                onClick={onSecondary}
                className="inline-flex px-5 py-3 rounded-xl bg-white/15 border border-white/30 font-semibold"
              >
                {secondaryLabel}
              </Link>
            ) : (
              <button
                type="button"
                disabled={busy}
                onClick={onSecondary}
                className="px-5 py-3 rounded-xl bg-white/15 border border-white/30 font-semibold disabled:opacity-60"
              >
                {secondaryLabel}
              </button>
            )
          ) : null}
          {onToggleDetails ? (
            <button
              type="button"
              onClick={onToggleDetails}
              className="px-5 py-3 rounded-xl bg-transparent border border-white/25 font-semibold opacity-90"
            >
              {detailsOpen ? "Details ausblenden" : "Bogen & Details"}
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default MatchResultScreen;
